import type { Exercise } from '../types/exercise';
import raw from './exercises.json';

export const EXERCISES: readonly Exercise[] = raw as Exercise[];

const BY_ID = new Map<string, Exercise>(EXERCISES.map((ex) => [ex.id, ex]));

export function getExerciseById(id: string): Exercise | undefined {
  return BY_ID.get(id);
}

export function requireExerciseById(id: string): Exercise {
  const ex = BY_ID.get(id);
  if (!ex) {
    throw new Error(`Exercise nicht gefunden: ${id}`);
  }
  return ex;
}
